// https://vuex.vuejs.org/en/actions.html

import NewApiService from "@/utils/new.api.service";

export default {
  index(context, params) {
    const { sortBy, descending, page, rowsPerPage } = params.pagination
      ? params.pagination
      : [null, null, null, null];
    context.commit("set_loading");
    return new Promise((resolve, reject) => {
      NewApiService.get("fitting-type", {
        page: page,
        sortBy: sortBy,
        descending: descending,
        rowsPerPage: rowsPerPage,
        search: params.search
      })
        .then(({ data }) => {
          context.commit("set_fitting_types", data);
          resolve(data);
        })
        .catch(({ response }) => {
          reject(response)
          context.commit("set_error", response.data.errors);
        })
        .finally(() => {
          context.commit("unset_loading");
        })
    });
  },
  list(context) {
    context.commit("set_loading");
    return new Promise((resolve, reject) => {
      NewApiService.get("fitting-type")
        .then(({ data }) => {
          context.commit("set_fitting_types", data);
          resolve(data);
        })
        .catch(({ response }) => {
          reject(response)
          context.commit("set_error", response.data.errors);
        })
        .finally(() => {
          context.commit("unset_loading");
        })
    });
  },
  add(context, params) {
    context.commit("set_loading");
    return new Promise((resolve, reject) => {
      NewApiService.post("fitting-type", params.model)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          reject(response)
          context.commit("set_error", response.data.errors);
        })
        .finally(() => {
          context.commit("unset_loading");
        })
    });
  },
  update(context, params) {
    context.commit("set_loading");
    return new Promise((resolve, reject) => {
      NewApiService.put("fitting-type/" + params.model.id, params.model)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          reject(response)
          context.commit("set_error", response.data.errors);
        })
        .finally(() => {
          context.commit("unset_loading");
        })
    });
  },
  delete(context, params) {
    context.commit("set_loading");
    return new Promise((resolve, reject) => {
      NewApiService.delete("fitting-type/" + params.model.id)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          reject(response)
          context.commit("set_error", response.data.errors);
        })
        .finally(() => {
          context.commit("unset_loading");
        })
    });
  },
  toggle(context, params) {
    context.commit("set_loading");
    return new Promise((resolve, reject) => {
      NewApiService.put("fitting-type/" + params.model.id+"/toggle",params.model)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          reject(response)
          context.commit("set_error", response.data.errors);
        })
        .finally(() => {
          context.commit("unset_loading");
        })
    });
  }
};
